import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

const { color } = tokens

const cardShadow = '0 4px 6px rgba(98, 102, 113, 0.06), 0 2px 2px rgba(98, 102, 113, 0.06)'

// Dos secciones sobre el fondo de la página (sin el contenedor gris de antes): paneles prediseñados
// en tarjetas de 6 px como el resto, y el panel personalizado en una tarjeta con borde discontinuo
export const DashboardWizardStyled = styled.div`
  padding: 30px 60px;

  .title {
    margin: 8px 0 24px;
  }

  .wizard-section + .wizard-section {
    margin-top: 32px;
  }

  .section-title {
    margin: 0 0 4px;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: ${color.text.primary};
  }

  .section-copy {
    margin: 0 0 16px;
    font-size: 14px;
    line-height: 20px;
    color: ${color.text.tertiary};
  }

  .preset-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 16px;
  }

  .preset-card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    height: 100%;
    padding: 20px;
    font-family: ${tokens.typography.fontFamily.primary};
    text-align: left;
    background: ${color.background.default};
    border: 1px solid transparent;
    border-radius: 6px;
    box-shadow: ${cardShadow};
    cursor: pointer;
    transition: border-color 0.2s ease;

    :hover,
    :focus-visible {
      border-color: ${props => props.theme.primary || color.brand.primary};
      outline: none;
    }
  }

  .preset-image {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    margin-bottom: 8px;
    border-radius: 8px;
    background: ${color.background.light};

    img {
      width: 32px;
      height: 32px;
      object-fit: contain;
    }
  }

  .preset-name {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: ${color.text.primary};
  }

  .preset-description {
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-size: 13px;
    line-height: 18px;
    color: ${color.text.tertiary};
  }

  .custom-card {
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-width: 460px;
    padding: 20px;
    background: ${color.background.default};
    border: 1.5px dashed ${color.border.default};
    border-radius: 6px;
    transition: border-color 0.2s ease;

    :hover,
    &.active {
      border-color: ${props => props.theme.primary || color.brand.primary};
    }
  }

  .custom-trigger {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0;
    font-family: ${tokens.typography.fontFamily.primary};
    font-size: 14px;
    font-weight: 500;
    color: ${color.text.secondary};
    background: transparent;
    border: 0;
    cursor: pointer;

    svg {
      color: ${props => props.theme.primary || color.brand.primary};
    }
  }

  .custom-form {
    display: flex;
    align-items: center;
    gap: 12px;

    > *:first-child {
      flex: 1 1 auto;
    }
  }
`
